export default {"src":"/_next/static/media/managers.fc73b5f8.svg","height":53,"width":53};